const toLongTimeZonedDateText = (date: Date, timeZone: string, locale = 'en-US') => {
  const formatter = Intl.DateTimeFormat(locale, {
    dateStyle: 'full',
    timeZone,
  })

  return formatter.format(date)
}

const toShortTimeZonedDateText = (date: Date, timeZone: string, locale = 'en-US') => {
  const formatter = Intl.DateTimeFormat(locale, {
    hour: 'numeric',
    minute: '2-digit',
    timeZone,
    timeZoneName: 'short',
    hourCycle: 'h12',
  })

  return formatter.format(date)
}

export { toLongTimeZonedDateText, toShortTimeZonedDateText }
